import { client } from "./graphql/client";
import { GET_LIST, DELETE } from 'react-admin';
import { getCardsV2Query } from "./graphql/card/query";
import { deleteCardV2Mutation } from "./graphql/card/mutations";

export const cardsV2DataProvider = {
  async getList(resource, params) {
    const { customerId } = params;
    const result = await client.query({ query: getCardsV2Query, variables: { customerId }, fetchPolicy: 'no-cache' });
    const items = result?.data?.getCardV2_Admin || result?.data?.getCardV2 || [];
    return { data: items, total: items.length };
  },

  async delete(resource, params) {
    const { id } = params;
    await client.mutate({ mutation: deleteCardV2Mutation, variables: { input: { cardId: id } } });
    return { data: { id } };
  },
};


